import React from 'react'

import style from './Header.module.css'

export default function Header({ children }) {
  return <header className={style.container}>{children}</header>
}

Header.layoutElementName = 'Header'
